<template>

  <div class="row">
    <div class="col-md-12">

      <div class="row" v-if="totalRecords === 0">
        <div class="col-md-12 mt-4">
          <div class="alert alert-info"><h5 class="pt-2"><em>{{ $t('text.globals.noOptions') }}</em></h5></div>
        </div>
      </div>

      <div class="row" v-if="totalRecords > 0">

        <div class="col-md-3 mt-4">

          <div class="row">
            <div class="col-md-12 mt-2">
              <div class="row">
                <div class="col-md-7">
                  <h5 v-if="filtersQuery.length > 0 || queryResult.length > 0">
                    {{ $t('text.searchResults.filters') }}</h5>
                </div>
                <div class="col-md-5">
                  <a class="btn btn-link btn-sm text-info" v-if="filtersQuery.length > 0"
                     @click="(e) => { clearFiltersQuery(); $parent.submitQuery(true); }"><small>{{
                      $t('text.searchResults.clearFilters')
                    }}</small></a>
                </div>
              </div>
            </div>
          </div>

          <div class="row searchFilters" v-if="filtersQuery.length > 0 || queryResult.length > 0">
            <div class="col-md-12">

              <div class="card mb-1" v-if="mimeTypeFacets.length">
                <div class="card-body">
                  <h6>{{ $t('text.metadata.mimeTypeName') }}</h6>
                  <ul>
                    <li v-for="(item,index) in mimeTypeFacets" @click="onFilterClick(item.filterQuery, 'mimetype')"
                        :key="'vrsta_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.display ? item.display : item.label }} <span class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-1" v-if="context && context.facetQueries && context.facetQueries.length">
                <div class="card-body">
                  <h6>{{ $t('text.searchResults.size') }}</h6>
                  <ul>
                    <li v-for="(item,index) in context.facetQueries" @click="onFilterClick(item.filterQuery, 'size')"
                        :key="'velikost_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.label }} <span class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-1" v-if="klasifikacijskaOznakaRazredaFacets.length">
                <div class="card-body">
                  <h6>{{ $t('text.searchResults.classificationLabel') }}</h6>
                  <ul>
                    <li v-for="(item,index) in klasifikacijskaOznakaRazredaFacets"
                        @click="onFilterClick(item.filterQuery, 'klasifikacijskaOznakaRazreda')" :key="'ko_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.label }} <span class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-1" v-if="statusGradivaFacets.length">
                <div class="card-body">
                  <h6>{{ $t('text.searchResults.documentStatus') }}</h6>
                  <ul>
                    <li v-for="(item,index) in statusGradivaFacets"
                        @click="onFilterClick(item.filterQuery, 'statusGradiva')" :key="'status_gradiva_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.label }} <span class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-1" v-if="courtFacets.length">
                <div class="card-body">
                  <h6>{{ $t('text.globals.court') }}</h6>
                  <ul>
                    <li v-for="(item,index) in courtFacets" @click="onFilterClick(item.filterQuery, 'sodišče')"
                        :key="'sodisce_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.label }} <span class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-1" v-if="caseReferenceNumberFacets.length">
                <div class="card-body">
                  <h6>{{ $t('text.globals.caseNumber') }}</h6>
                  <ul>
                    <li v-for="(item,index) in caseReferenceNumberFacets"
                        @click="onFilterClick(item.filterQuery, 'opravilnaŠtevikaZadeve')" :key="'opr_st_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.label }} <span class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-1" v-if="povezanSistemFacets.length">
                <div class="card-body">
                  <h6>{{ $t('text.searchResults.connectedSystemLabel') }}</h6>
                  <ul>
                    <li v-for="(item,index) in povezanSistemFacets"
                        @click="onFilterClick(item.filterQuery, 'oznakaPovezanegaSistema')"
                        :key="'oznaka_povezanega_sistema_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.label }} <span class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-1" v-if="oznakaVpisnikaFacets.length">
                <div class="card-body">
                  <h6>{{ $t('text.searchResults.registryLabel') }}</h6>
                  <ul>
                    <li v-for="(item,index) in oznakaVpisnikaFacets"
                        @click="onFilterClick(item.filterQuery, 'oznakaVpisnika')" :key="'oznaka_vpisnika_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.label }} <span class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>


              <div class="card mb-1" v-if="fizicnoGradivoFacets.length">
                <div class="card-body">
                  <h6>{{ $t('text.searchResults.physicalFormDocument') }}</h6>
                  <ul>
                    <li v-for="(item,index) in fizicnoGradivoFacets"
                        @click="onFilterClick(item.filterQuery, 'oznakaPovezanegaSistema')"
                        :key="'gradivo_v_fizicni_obliki_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.label === 'true' ? $t('text.globals.yes') : $t('text.globals.no') }} <span
                        class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-1" v-if="rokHrambeFacets.length">
                <div class="card-body">
                  <h6>{{ $t('text.classificationPlanMetadata.expiration') }}</h6>
                  <ul>
                    <li v-for="(item,index) in rokHrambeFacets" @click="onFilterClick(item.filterQuery, 'rokHrambe')"
                        :key="'rok_hrambe_' + index">
                      <i v-if="filtersQuery.indexOf(item.filterQuery) > -1" class="fa fa-check-circle text-success"></i>
                      {{ item.label }} <span class="badge badge-secondary">{{ item.count }}</span>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-md-9 mt-4">
          <div class="row">
            <div class="col-md-7 mt-2">
              <h5 v-if="queryResult.length > 0">{{ $t('text.searchResults.searchResults1') }} <span class="text-muted"
                                                                                                    v-if="queryResult.length > 0 || filtersQuery.length > 0">({{
                  totalRecords
                }} {{ $t('text.searchResults.searchResults2') }})</span>
                <div class="badge badge-info" v-if="$parent.selectedDocuments.length > 0">
                  {{ $t('text.searchResults.searchResultsWithSelection.numOfSelectedDocuments') }}:
                  {{ $parent.selectedDocuments.length }}
                </div>
              </h5>
            </div>
            <div class="col-md-5 text-right">

              <div v-if="totalRecords > 0" class="float-right ml-2">
                <b-dropdown class="tableSettings" style="top: auto; left: auto;" variant="primary">
                  <template v-slot:button-content>
                    <i class="fa fa-cog"></i>
                  </template>
                  <b-dropdown-item v-for="(column, index) in columns" :key="index"
                                   class="pt-0 pb-0">
                    <label class="d-block font-weight-normal pt-0 pb-0 mb-0"
                           :for="column.label"
                           @click.prevent.stop="toggleColumn( index, $event )"><i
                        :class="{ 'fas fa-check-square': !column.hidden, 'far fa-square': column.hidden }"></i>&nbsp;{{
                        column.label
                      }}</label>
                  </b-dropdown-item>
                </b-dropdown>
              </div>

              <a class="btn btn-primary text-white float-right mx-2" id="exportStorageDatesBtn"
                 @click.prevent.stop="exportStorageDates()"
                 :title="$t('text.searchResults.searchResultsWithSelection.expirationsExport')"
                 v-if="$globalFunctions.checkForPermission('IZVOZ_ROKOV')"><i class="fas fa-file-export"></i></a>

              <div class="float-right" v-if="queryResult">
                <GenerateReportButton
                    id="listReportsBtn"
                    v-if="query && appSection !== 'OIIU' && appSection !== 'OIIU-pretecenRokHrambe' && appSection !== 'OIIU-dodeljenoVPregled' && appSection !== 'OIIU-kandidatiZaIzrocanje'
                  && appSection !== 'OIIU-gradivoPregledanoSStraniArhiva' && appSection !== 'OIIU-gradivoPrimernoZaPredajoVArhiv' && appSection !== 'OIIU-gradivoPredlaganoZaUnicenje' && appSection !== 'OIIU-popisDoukemtarnegaGradivaZaUnicenje'"
                    :query="query"
                    :serverParams="serverParams"
                    :searchFieldsText="searchFieldsText"
                    :filtersQuery="filtersQuery"
                    :guiLocation="'GRADIVO_ISKANJE'"
                    :searchType="searchType"
                    :context="context"
                />

                <GenerateReportButton
                    id="dodeljenoVPregledBtn"
                    v-if="appSection === 'OIIU-dodeljenoVPregled'"
                    :query="query"
                    :serverParams="serverParams"
                    :searchFieldsText="searchFieldsText"
                    :filtersQuery="filtersQuery"
                    :guiLocation="'OIIU_DODELJENO'"
                    :searchType="searchType"
                    :context="context"
                />

                <GenerateReportButton
                    id="pretecenRokHrambeBtn"
                    v-if="appSection === 'OIIU-pretecenRokHrambe'"
                    :query="query"
                    :serverParams="serverParams"
                    :searchFieldsText="searchFieldsText"
                    :filtersQuery="filtersQuery"
                    :guiLocation="'PRETECENI_DATUM'"
                    :searchType="searchType"
                    :context="context"
                />

                <GenerateReportButton
                    id="kandidatiZaIzrocanjeBtn"
                    v-if="appSection === 'OIIU-kandidatiZaIzrocanje'"
                    :query="query"
                    :serverParams="serverParams"
                    :searchFieldsText="searchFieldsText"
                    :filtersQuery="filtersQuery"
                    :guiLocation="'OIIU_KANDIDATI_IZROCITEV'"
                    :searchType="searchType"
                    :context="context"
                />

                <GenerateReportButton
                    id="gradivoPregledanoSStraniArhivaBtn"
                    v-if="appSection === 'OIIU-gradivoPregledanoSStraniArhiva'"
                    :query="query"
                    :serverParams="serverParams"
                    :searchFieldsText="searchFieldsText"
                    :filtersQuery="filtersQuery"
                    :guiLocation="'OIIU_PREGLEDANO_ARHIV'"
                    :searchType="searchType"
                    :context="context"
                />

                <GenerateReportButton
                    id="popisDoukemtarnegaGradivaZaUnicenjeBtn"
                    v-if="appSection === 'OIIU-popisDoukemtarnegaGradivaZaUnicenje'"
                    :query="query"
                    :serverParams="serverParams"
                    :searchFieldsText="searchFieldsText"
                    :filtersQuery="filtersQuery"
                    :guiLocation="'BRISANJE'"
                    :searchType="searchType"
                    :context="context"
                />

                <GenerateReportButton
                    id="gradivoPrimernoZaPredajoVArhivBtn"
                    v-if="appSection === 'OIIU-gradivoPrimernoZaPredajoVArhiv'"
                    :query="query"
                    :serverParams="serverParams"
                    :searchFieldsText="searchFieldsText"
                    :filtersQuery="filtersQuery"
                    :guiLocation="'OIIU_PRIMERNO_ARHIV'"
                    :searchType="searchType"
                    :context="context"
                />

                <GenerateReportButton
                    id="gradivoPredlaganoZaUnicenjeBtn"
                    v-if="appSection === 'OIIU-gradivoPredlaganoZaUnicenje'"
                    :query="query"
                    :serverParams="serverParams"
                    :searchFieldsText="searchFieldsText"
                    :filtersQuery="filtersQuery"
                    :guiLocation="'OIIU_PREDLAGANO_UNICENJE'"
                    :searchType="searchType"
                    :context="context"
                />

                <GenerateReportButton
                    id="selectableReportsBtn"
                    v-if="(query && typeof appSection === 'undefined') || (query && (appSection !== 'OIIU' && appSection !== 'OIIU-pretecenRokHrambe' && appSection !== 'OIIU-dodeljenoVPregled' && appSection !== 'OIIU-kandidatiZaIzrocanje'
                  && appSection !== 'OIIU-gradivoPregledanoSStraniArhiva' && appSection !== 'OIIU-gradivoPrimernoZaPredajoVArhiv' && appSection !== 'OIIU-gradivoPredlaganoZaUnicenje'))"
                    :query="query"
                    :serverParams="serverParams"
                    :filtersQuery="filtersQuery"
                    :guiLocation="'GRADIVO_IZBOR'"
                    :searchType="searchType"
                    :context="context"
                    :searchFieldsText="searchFieldsText"
                />
              </div>

            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive searchResultsTableContainer">

                <table class="table searchResults" v-if="totalRecords > 0">
                  <thead>
                  <tr>
                    <th @click.stop="$parent.onThCheckboxClick($event)" id="selectAllTh" class="text-center">
                      <label>
                        <input id="selectAllCheckbox" ref="selectAllCheckbox" type="checkbox" class="form-check"
                               :title="$t('text.searchResults.searchResultsWithSelection.selectAllDocumentsOnCurrentPage')"
                               v-b-tooltip.hover/>
                      </label>
                    </th>
                    <th>#</th>
                    <th v-for="(item,index) in columns" v-if="!item.hidden" style="min-width: 200px;"
                        :style="item.style ? item.style : ''" @click="onThClick(index)">
                      {{ item.label }}
                      <div class="float-right text-center" style="width: 30px">
                                                                        <span
                                                                            v-if="typeof(item.sort.ascending) !== 'undefined'">
                                                                            <i :class="item.sort.ascending ? 'fa fa-chevron-down' : 'fa fa-chevron-up'"></i>
                                                                        </span>
                      </div>
                    </th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr v-for="(item,index) in queryResult" @click="$parent.onRowClick(item.entry)">
                    <td @click.stop="() => { $parent.onCheckboxClick($event, item.entry.id); checkIfHeaderCheckboxShouldBeChecked();}"
                        class="text-center">
                      <label>
                        <input type="checkbox" class="form-check" :key="item.entry.id"
                               :checked="$parent.selectedDocuments.indexOf(item.entry.id) > -1"/>
                      </label>
                    </td>
                    <td>{{ index + 1 + ((serverParams.page - 1) * serverParams.perPage) }}</td>

                    <td v-if="!columns[0].hidden">
                                                                    <span
                                                                        v-if="item.entry.properties && item.entry.properties['EH:tip_gradiva']">
                                                                        <span
                                                                            v-if="item.entry.properties && item.entry.properties['EH:tip_gradiva'] === 1"
                                                                            class="badge badge-info d-inline-block"
                                                                            :title="$globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:tip_gradiva', item.entry.properties['EH:tip_gradiva'])"
                                                                            v-b-tooltip.hover>V</span>
                                                                        <span
                                                                            v-if="item.entry.properties && item.entry.properties['EH:tip_gradiva'] === 2"
                                                                            class="badge badge-success d-inline-block"
                                                                            :title="$globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:tip_gradiva', item.entry.properties['EH:tip_gradiva'])"
                                                                            v-b-tooltip.hover>P</span>
                                                                    </span>
                      <span v-else>
                                                                        <span
                                                                            class="badge badge-secondary d-inline-block"><span
                                                                            class="text-monospace">/</span></span>
                                                                    </span>

                      <!--                                                                    <span v-if="item.entry.properties && item.entry.properties['EH:komponenta_povezave_na_dokumente']">-->
                      <!--                                                                        <label class="badge badge-warning">K</label>-->
                      <!--                                                                    </span>-->

                      <span>
                                                                        <i v-if="item.entry.isFile && !item.entry.isFolder"
                                                                           :class="$globalFunctions.getFileTypeIcon(item.entry.content ? item.entry.content.mimeType : 'unknown')"></i>
                                                                        <i v-if="item.entry.isFolder && !item.entry.isFile"
                                                                           class="fa fa-folder-open"></i>
                                                                        <i v-if="!item.entry.isFolder && !item.entry.isFile"
                                                                           class="fa fa-question"></i>
                                                                    </span>
                      {{
                        (item.entry.properties && item.entry.properties["cm:title"]) ? item.entry.properties["cm:title"] : item.entry.name
                      }}

                      <div v-if="!item.entry.content">
                        <b-badge variant="danger">{{ $t('text.documentDetails.documentDeleted') }}</b-badge>
                      </div>
                    </td>
                    <td v-if="columns[1] && !columns[1].hidden">{{ item.entry.id }}</td>
                    <td v-if="columns[2] && !columns[2].hidden">
                      {{
                        item.entry.properties && item.entry.properties["cm:description"] ? item.entry.properties["cm:description"] : '/'
                      }}
                    </td>
                    <td v-if="columns[3] && !columns[3].hidden">
                      {{
                        (item.entry.properties && item.entry.properties["EH:rok_hrambe"] && item.entry.properties["EH:rok_hrambe"] !== 5) ? shortenRokHrambe(item.entry.properties["EH:rok_hrambe"]) : ''
                      }}
                      {{
                        (item.entry.properties && item.entry.properties["EH:rok_hrambe"] && item.entry.properties["EH:rok_hrambe"] === 5) ? (item.entry.properties && item.entry.properties["EH:trajanje_roka_hrambe"] ? item.entry.properties["EH:trajanje_roka_hrambe"] : '/') : ''
                      }}
                      {{ (item.entry.properties && item.entry.properties["EH:rok_hrambe"]) ? '' : '/' }}
                    </td>
                    <!--                                    <td v-if="columns[4] && !columns[4].hidden">{{item.entry.properties && item.entry.properties["EH:trajanje_roka_hrambe"] ? item.entry.properties["EH:trajanje_roka_hrambe"] : '/'}}</td>-->
                    <td v-if="columns[4] && !columns[4].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:klasifikacijska_oznaka_razreda"] ? item.entry.properties["EH:klasifikacijska_oznaka_razreda"] : '/'
                      }}
                    </td>
                    <td v-if="columns[5] && !columns[5].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:ID_gradiva"] ? item.entry.properties["EH:ID_gradiva"] : '/'
                      }}
                    </td>
                    <td v-if="columns[6] && !columns[6].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:datum_zacetka_teka_roka_hrambe"] ? moment.utc(item.entry.properties["EH:datum_zacetka_teka_roka_hrambe"]).local().format('DD. MM. YYYY ob HH:mm') : '/'
                      }}
                    </td>
                    <td v-if="columns[7] && !columns[7].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:datum_izteka_roka_hrambe"] ? moment.utc(item.entry.properties["EH:datum_izteka_roka_hrambe"]).local().format('DD. MM. YYYY ob HH:mm') : '/'
                      }}
                    </td>
                    <td v-if="columns[8] && !columns[8].hidden">
                      {{
                        item.entry.createdAt ? moment.utc(item.entry.createdAt).local().format('DD. MM. YYYY ob HH:mm') : '/'
                      }}
                    </td>
                    <td v-if="columns[9] && !columns[8].hidden">
                      {{
                        item.entry.modifiedAt ? moment.utc(item.entry.modifiedAt).local().format('DD. MM. YYYY ob HH:mm') : '/'
                      }}
                    </td>
                    <td v-if="columns[10] && !columns[10].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:datum_gradiva"] ? moment.utc(item.entry.properties["EH:datum_gradiva"]).local().format('DD. MM. YYYY ob HH:mm') : '/'
                      }}
                    </td>
                    <td v-if="columns[11] && !columns[11].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:status_gradiva"] ? item.entry.properties["EH:status_gradiva"] + " - " + $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:status_gradiva', item.entry.properties["EH:status_gradiva"]) : '/'
                      }}
                    </td>
                    <td v-if="columns[12] && !columns[12].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:opravilna_stevilka_zadeve"] ? item.entry.properties["EH:opravilna_stevilka_zadeve"] : '/'
                      }}
                    </td>
                    <td v-if="columns[13] && !columns[13].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:sodisce"] ? item.entry.properties["EH:sodisce"] + " - " + $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:sodisce', item.entry.properties["EH:sodisce"]) : '/'
                      }}
                    </td>
                    <td v-if="columns[14] && !columns[14].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:oznaka_povezanega_sistema"] ? item.entry.properties["EH:oznaka_povezanega_sistema"] + " - " + $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:oznaka_povezanega_sistema', item.entry.properties["EH:oznaka_povezanega_sistema"]) : '/'
                      }}
                    </td>
                    <td v-if="columns[15] && !columns[15].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:ustreznost_formata"] ? item.entry.properties["EH:ustreznost_formata"] + " - " + $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:ustreznost_formata', item.entry.properties["EH:ustreznost_formata"]) : '/'
                      }}
                    </td>
                    <td v-if="columns[16] && !columns[16].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:mesto_hrambe"] ? item.entry.properties["EH:mesto_hrambe"] + " - " + $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:mesto_hrambe', item.entry.properties["EH:mesto_hrambe"]) : '/'
                      }}
                    </td>
                    <td v-if="columns[17] && !columns[17].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:stopnja_zaupnosti"] ? item.entry.properties["EH:stopnja_zaupnosti"] + " - " + $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:stopnja_zaupnosti', item.entry.properties["EH:stopnja_zaupnosti"]) : '/'
                      }}
                    </td>
                    <td v-if="columns[18] && !columns[18].hidden">
                      <span
                          v-if="item.entry.content && item.entry.content.sizeInBytes">{{
                          item.entry.content.sizeInBytes| prettyBytes
                        }}</span>
                      <span v-else>/</span>
                    </td>
                    <td v-if="columns[19] && !columns[19].hidden">
                      <span
                          v-if="item.entry.content && item.entry.content.mimeType">{{
                          item.entry.content.mimeType
                        }}</span>
                      <span v-else>/</span>
                    </td>
                    <td v-if="columns[20] && !columns[20].hidden">
                      {{
                        item.entry.properties && item.entry.properties["EH:tip_gradiva"] ? item.entry.properties["EH:tip_gradiva"] + " - " + $globalFunctions.getReadableCodeListValueFromProperty(allMetadataOptions, 'EH:tip_gradiva', item.entry.properties["EH:tip_gradiva"]) : '/'
                      }}
                    </td>
                  </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="row mb-2" v-if="totalRecords > 0">
            <div class="col-md-12">
              <form class="form-inline">
                <div class="form-group w-100">
                  <small
                      class="float-left mr-1">{{
                      $t('text.searchResults.searchResultsWithSelection.numOfResultsPerPage')
                    }}</small>
                  <v-select
                      class="col-md-2 form-control float-left py-0"
                      v-model="itemsPerPage"
                      :options="[10, 25, 50, 100, 500, 5000]"
                      :clearable="false"
                      @input="() => {savePerPageValue(); $parent.onPerPageChange();}">
                  </v-select>
                </div>
              </form>
            </div>
          </div>
          <div class="row" v-if="totalRecords > 0">
            <div class="col-md-12">
              <b-pagination
                  class="list-inline mx-auto justify-content-center"
                  v-model="serverParams.page"
                  :total-rows="totalRecords"
                  :per-page="serverParams.perPage"
                  limit="10"
                  @change="(params) => { $parent.onPageChange(params); $refs.selectAllCheckbox.checked = false; $forceUpdate(); }"
              >
                <template v-slot:first-text><span><i
                    class="fas fa-fast-backward"></i></span></template>
                <template v-slot:prev-text><span><i
                    class="fas fa-step-backward"></i></span></template>
                <template v-slot:next-text><span><i
                    class="fas fa-step-forward"></i></span></template>
                <template v-slot:last-text><span><i
                    class="fas fa-fast-forward"></i></span></template>
              </b-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from "axios/index";
import GenerateReportButton from "./GenerateReportButton";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: 'SearchResultsWithSelection',
  components: {
    GenerateReportButton,
    vSelect
  },
  props: [
    'appSection',
    'queryResult',
    'filtersQuery',
    'columns',
    'context',
    'totalRecords',
    'serverParams',
    'query',
    'searchFieldsText',
    'searchType'
  ],
  data: function () {
    return {
      // queryResult: {},
      // filtersQuery: props.filtersQuery,
      // columns: props.columns,
      // totalRecords: props.totalRecords,
      allMetadataOptions: [],
      itemsPerPage: 10
      // filtersQuery: props.filtersQuery,
      // context: {},
    }
  },

  watch: {
    queryResult: {
      handler(val, oldVal) {
        if (this.$refs.selectAllCheckbox) {
          this.$refs.selectAllCheckbox.checked = false;
        }
      }
    }
  },

  computed: {

    mimeTypeFacets: function () {
      const _this = this;

      let filtered = _.filter(_this.context.facetsFields, {label: 'mimetype'});

      return filtered.length ? filtered[0].buckets : []
    },

    statusGradivaFacets: function () {
      const _this = this;
      let filtered = _.filter(_this.context.facetsFields, {label: 'statusGradiva'});

      if (filtered.length) {
        filtered = _.map(filtered[0].buckets, function (val, key) {
          val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:status_gradiva', parseInt(val.label));
          return val
        });
      }

      return filtered.length ? filtered : []
    },

    klasifikacijskaOznakaRazredaFacets: function () {
      const _this = this;
      let filtered = _.filter(_this.context.facetsFields, {label: 'klasifikacijskaOznakaRazreda'});

      if (filtered.length) {
        filtered = _.map(filtered[0].buckets, function (val, key) {
          val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:klasifikacijska_oznaka_razreda', val.label);
          return val
        });
      }

      return filtered.length ? filtered : []
    },

    courtFacets: function () {
      const _this = this;
      let filtered = _.filter(_this.context.facetsFields, {label: 'sodišče'});

      if (filtered.length) {
        filtered = _.map(filtered[0].buckets, function (val, key) {
          val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:sodisce', val.label);
          return val
        });
      }

      return filtered.length ? filtered : []
    },

    caseReferenceNumberFacets: function () {
      const _this = this;
      let filtered = _.filter(_this.context.facetsFields, {label: 'opravilnaŠtevikaZadeve'});

      if (filtered.length) {
        filtered = _.map(filtered[0].buckets, function (val, key) {
          val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:opravilna_stevilka_zadeve', val.label);
          return val
        });
      }

      return filtered.length ? filtered : []
    },

    povezanSistemFacets: function () {
      const _this = this;
      let filtered = _.filter(_this.context.facetsFields, {label: 'oznakaPovezanegaSistema'});

      if (filtered.length) {
        filtered = _.map(filtered[0].buckets, function (val, key) {
          val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:oznaka_povezanega_sistema', val.label);
          return val
        });
      }

      return filtered.length ? filtered : []
    },

    oznakaVpisnikaFacets: function () {
      const _this = this;
      let filtered = _.filter(_this.context.facetsFields, {label: 'oznakaVpisnika'});

      if (filtered.length) {
        filtered = _.map(filtered[0].buckets, function (val, key) {
          val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:oznaka_vpisnika', val.label);
          return val
        });
      }

      return filtered.length ? filtered : []
    },

    fizicnoGradivoFacets: function () {
      const _this = this;
      let filtered = _.filter(_this.context.facetsFields, {label: 'fizičnoGradivo'});

      return filtered.length ? filtered[0].buckets : []
    },

    rokHrambeFacets: function () {
      const _this = this;
      let filtered = _.filter(_this.context.facetsFields, {label: 'rokHrambe'});

      if (filtered.length) {
        filtered = _.map(filtered[0].buckets, function (val, key) {
          val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:rok_hrambe', parseInt(val.label));
          return val
        });
      }

      return filtered.length ? filtered : []
    }
  },

  mounted: function () {
    const _this = this;

    console.log(_this.$route.params.queryParam);

    // if (_this.$route.params.queryParam) {
    //   _this.exampleQuery = decodeURIComponent(_this.queryParam);
    //   _this.$parent.submitQuery(true);
    // }

    let p1 = _this.$store.dispatch("retrieveAllMetadataOptions");
    let p2 = _this.$store.dispatch("retrieveReportTypeOptions");
    let p3 = _this.$store.dispatch("retrieveCodeListProperties");

    Promise.all([p1,p2,p3]).then((values) => {
      _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
      _this.itemsPerPage = _this.$store.getters.getItemsPerPage;
    });
  },

  methods: {

    shortenRokHrambe(val) {
      let rokHrambe = this.$globalFunctions.getReadableCodeListValueFromProperty(this.allMetadataOptions, 'EH:rok_hrambe', parseInt(val));
      console.log("typeof", typeof rokHrambe);
      if (rokHrambe && typeof rokHrambe === 'string') {
        rokHrambe = rokHrambe.substring(0, 1);
      }
      return rokHrambe;
    },

    clearFiltersQuery() {
      const _this = this;

      _this.$emit("clearFiltersQuery");
      _this.$parent.filtersQuery = [];
      _this.$parent.selectedDocuments = [];
      _this.$store.dispatch("setSelectedDocuments", []);
      _this.$forceUpdate();
      _this.$parent.submitQuery(true);
    },

    onFilterClick(filterQuery) {
      const _this = this;

      console.log("_this.filtersQuery", _this.filtersQuery);
      console.log("filterQuery", filterQuery);
      console.log("index", _this.filtersQuery.indexOf(filterQuery));

      if (_this.filtersQuery.indexOf(filterQuery) > -1) {
        _this.filtersQuery.splice(_this.filtersQuery.indexOf(filterQuery), 1);
      } else {
        _this.filtersQuery.push(filterQuery);
      }

      let p1 = _this.$store.dispatch("setSelectedDocuments", []);
      let p2 = _this.$store.dispatch("setOffsetTop", document.documentElement.scrollTop);

      Promise.all([p1]).then((values) => {
        _this.$forceUpdate();
        _this.$parent.selectedDocuments = [];
        _this.$parent.submitQuery(true);
      });


    },

    onThClick(index) {
      const _this = this;
      console.log("index: ", index);
      console.log("Object.keys(_this.columns[index].sort).length", Object.keys(_this.columns[index].sort).length);
      console.log("_this.columns[index].sort", _this.columns[index]);
      // column is not sortable
      if (_this.columns[index].sort === false) {
        return;
      }

      // allow sorting only by 1 column
      _.map(_this.columns, function (item, i) {
        if (item !== _this.columns[index] && item.sort) {
          item.sort = {};
        }
      });

      if (typeof (_this.columns[index].sort.ascending) === 'undefined') {
        _this.columns[index].sort = {"ascending": true};
      } else {
        if (_this.columns[index].sort.ascending) {
          _this.columns[index].sort = {"ascending": false};
        } else {
          _this.columns[index].sort = {};
        }
      }

      _this.$store.dispatch("setOffsetTop", document.documentElement.scrollTop);
      _this.$parent.onSortChange();
    },

    toggleColumn(index, event) {
      this.$set(this.columns[index], 'hidden', !this.columns[index].hidden);
    },

    exportStorageDates() {
      const _this = this;

      if (_this.$parent.selectedDocuments.length === 0) {
        swal(
            this.$t('text.searchResults.searchResultsWithSelection.documentsNotSelectedExportSwal.title'),
            this.$t('text.searchResults.searchResultsWithSelection.documentsNotSelectedExportSwal.prompt'),
            "error",
            {dangerMode: true}
        );
        return;
      }

      let data = {
        knIds: [],
        nodeIds: _this.$parent.selectedDocuments
      };

      axios.post(config.rootEhramba + 'rokiHrambeExport', data)
          .then((res) => {
            console.log("res", res);
            _this.$globalFunctions.downloadXmlFile(res.data, 'Izvoz_rokov_hrambe');
          })
          .catch((error) => {
            console.log("error", error);
          });

      console.log("Generate report for: " + _this.$parent.selectedDocuments);
    },

    sortByColumn(columnIndex) {
      const _this = this;

      console.log("columnIndex", columnIndex);
      console.log("server params - field", _this.serverParams.sort[0].field);
      console.log("server params - asc", _this.serverParams.sort[0].ascending);

    },

    savePerPageValue() {
      const _this = this;

      _this.$store.dispatch("setItemsPerPage", _this.itemsPerPage);
    },

    checkIfHeaderCheckboxShouldBeChecked() {
      const _this = this;

      if (_this.$parent.selectedDocuments.length === _this.itemsPerPage) {
        _this.$refs.selectAllCheckbox.checked = true;
      } else {
        _this.$refs.selectAllCheckbox.checked = false;
      }
      _this.$forceUpdate();
    }
  }

};
</script>



// WEBPACK FOOTER //
// src/components/SearchResultsWithSelection.vue